import ApiService from "@/services/api.service";

const route = "integrations";

const integrations = {
  get() {
    return new Promise((resolve, reject) => {
      ApiService.get(route).then(
        ({ data }) => {
          resolve(data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  add(_module) {
    return new Promise((resolve, reject) => {
      ApiService.post(route, _module).then(
        ({ data }) => {
          resolve(data);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

export default integrations;
